import { Map } from 'immutable';

import RecurringWorkspaceItemConstants from 'Shared/constants/RecurringWorkspaceItem.constants';

class RecurringWorkspaceItemHelper {
  static getId(recurringWorkspaceItem) {
    if (!Map.isMap(recurringWorkspaceItem)) {
      return false;
    }
    return recurringWorkspaceItem.get(RecurringWorkspaceItemConstants.Model.ID);
  }

  static getTimeOfDay(recurringWorkspaceItem) {
    if (!Map.isMap(recurringWorkspaceItem)) {
      return false;
    }
    return recurringWorkspaceItem.get(RecurringWorkspaceItemConstants.Model.TIME_OF_DAY);
  }

  static getDayOfWeek(recurringWorkspaceItem) {
    if (!Map.isMap(recurringWorkspaceItem)) {
      return false;
    }
    return recurringWorkspaceItem.get(RecurringWorkspaceItemConstants.Model.DAY_OF_WEEK);
  }

  static getIntervalUnit(recurringWorkspaceItem) {
    if (!Map.isMap(recurringWorkspaceItem)) {
      return false;
    }
    return recurringWorkspaceItem.get(RecurringWorkspaceItemConstants.Model.INTERVAL_UNIT);
  }

  static getIntervalAmount(recurringWorkspaceItem) {
    if (!Map.isMap(recurringWorkspaceItem)) {
      return false;
    }
    return recurringWorkspaceItem.get(RecurringWorkspaceItemConstants.Model.INTERVAL_AMOUNT);
  }

  static getStartsAt(recurringWorkspaceItem) {
    if (!Map.isMap(recurringWorkspaceItem)) {
      return false;
    }
    return recurringWorkspaceItem.get(RecurringWorkspaceItemConstants.Model.STARTS_AT);
  }

  static getDayInMonth(recurringWorkspaceItem) {
    if (!Map.isMap(recurringWorkspaceItem)) {
      return false;
    }
    return recurringWorkspaceItem.get(RecurringWorkspaceItemConstants.Model.DAY_IN_MONTH);
  }

  static getWeekInMonth(recurringWorkspaceItem) {
    if (!Map.isMap(recurringWorkspaceItem)) {
      return false;
    }
    return recurringWorkspaceItem.get(RecurringWorkspaceItemConstants.Model.WEEK_IN_MONTH);
  }

  static getOnlyRecurOnce(recurringWorkspaceItem) {
    if (!Map.isMap(recurringWorkspaceItem)) {
      return false;
    }
    return recurringWorkspaceItem.get(RecurringWorkspaceItemConstants.Model.ONLY_RECUR_ONCE);
  }

  static getIsSectionRule(recurringWorkspaceItem) {
    if (!Map.isMap(recurringWorkspaceItem)) {
      return false;
    }
    return recurringWorkspaceItem.get(RecurringWorkspaceItemConstants.Model.IS_SECTION_RULE);
  }

  static getSectionRuleId(recurringWorkspaceItem) {
    if (!Map.isMap(recurringWorkspaceItem)) {
      return false;
    }
    return recurringWorkspaceItem.get(RecurringWorkspaceItemConstants.Model.SECTION_RULE_ID);
  }
}

export default RecurringWorkspaceItemHelper;
